export default "__VITE_ASSET__D3xNq4YZ__"